import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from '~/decorators';
import './HeaderEvent.scss';

import oget from 'oget';
import moment from 'moment-timezone';
import HeaderHamburger from './HeaderHamburger';
import HeaderCategory from './HeaderCategory';
import Api from '../../../api';
import HeaderDocuments from './HeaderDocuments';

const { REACT_APP_DATE_TIME_FORMAT, REACT_APP_LOGOS_URL } = process.env;

@translate('home.header.header-event')
class HeaderEvent extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    contests: PropTypes.array.isRequired,
    contestsById: PropTypes.object.isRequired,
    round: PropTypes.any,
    apiTimeUpdated: PropTypes.any,
    colors: PropTypes.shape({
      hamburger: PropTypes.shape({
        default: PropTypes.shape({
          backgroundColor: PropTypes.string,
          color: PropTypes.string,
        }),
        active: PropTypes.shape({
          backgroundColor: PropTypes.string,
          color: PropTypes.string,
        }),
      }),
    }).isRequired,
    onToggleAutoSwitch: PropTypes.func.isRequired,
  };

  state = {
    logoClassName: '',
    documents: [],
    selectedDocumentUrl: '',
  };

  logoDisable = () =>
    this.setState({
      logoClassName: 'no-logo',
    });

  logoEnable = () =>
    this.setState({
      logoClassName: '',
    });

  async componentDidUpdate(prevProps) {
    const { contestsById, round } = this.props;

    if (!round) {
      return;
    }

    const roundId = oget(this.props.round, 'externalId');
    const prevRoundId = oget(prevProps.round, 'externalId');
    const hasRoundIdChanged = roundId !== prevRoundId;

    if (hasRoundIdChanged && roundId) {
      try {
        const eventId = oget(this.props.event, 'id');
        const contestId = contestsById[round.externalContestId]?.externalId;
        const documents = await Api.documentsList({ eventId, contestId, roundId });

        this.setState({ documents });
      } catch (err) {
        console.error('Failed to get the documents', err);
        this.setState({ documents: [] });
      }
    }
  }

  render() {
    const {
      t,
      locale,
      event: { filename: eventImage, location, name: eventName, externalUrl, timezoneUtc },
      contests,
      contestsById,
      round,
      categories,
      apiTimeUpdated,
      colors,
      onToggleAutoSwitch,
    } = this.props;

    const { logoClassName } = this.state;

    const externalContestId = oget(round, 'externalContestId');

    const contest = contestsById[externalContestId];

    moment.locale(locale.substr(0, 2));

    const localTime = moment(new Date()); // ToDo: this causes the component to trigger componentDidUpdate too often..
    localTime.tz(timezoneUtc);

    const timeUpdated = moment(apiTimeUpdated);
    timeUpdated.tz(timezoneUtc);
    return (
      <div className="header-event">
        <HeaderHamburger
          contests={contests}
          selectedContestId={externalContestId}
          roundSelected={round}
          colors={colors.hamburger}
          onToggleAutoSwitch={onToggleAutoSwitch}
        />

        <div className="info-container">
          <div className={`logo ${logoClassName}`}>
            <a href={externalUrl || undefined} target="_blank" rel="noreferrer">
              <img
                ref={(ref) => (this.image = ref)}
                alt={`${eventName} Logo`}
                src={`${REACT_APP_LOGOS_URL}/${eventImage}`}
                onLoad={this.logoEnable}
                onError={this.logoDisable}
                height="124"
              />
            </a>
          </div>

          <div className="info">
            <div className="name">{eventName}</div>

            <div className="type">
              {contest && `${contest.name} `}
              {round && round.name}
              {round && categories && categories.length > 1 && (
                <HeaderCategory
                  documents={this.state.documents}
                  rounds={contest.rounds}
                  round={round}
                  categories={categories}
                  colors={colors.hamburger}
                />
              )}
              {this.state.documents.length > 0 && <HeaderDocuments documents={this.state.documents} />}
            </div>

            <div className="times">
              <div className="location">{location && `${location.city}, ${location.country}`}</div>
              <div className="time local-time">
                {t('Local Time')} <span>{localTime.format(REACT_APP_DATE_TIME_FORMAT)}</span>
              </div>

              <div className="time">
                {t('Last Update')}{' '}
                <span>
                  {apiTimeUpdated && moment(timeUpdated).format(REACT_APP_DATE_TIME_FORMAT)}

                  {!apiTimeUpdated && t('N/A')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderEvent;
